import React, {forwardRef} from 'react';
import * as propTypes from 'prop-types';
import cn from 'classnames';

import Thumbnail from './Thumbnail';
import ThumbnailPreload from './Thumbnail.Preload';
import styles from './thumbnailDisplay.styles.scss';


const ThumbnailDisplay = forwardRef(({files, className, thumbnailClassName, totalSuccessFilesCount}, ref) => {
  const containerStyles = {};

  return (
    <div className={cn(styles.thumbnailCarouselContainer, className)} ref={ref} style={containerStyles}>
      <div className={styles.thumbnailCarousel}>
          {files?.map((file, idx) => (
            <Thumbnail
              key={`${file.name}${file.url}`}
              file={file}
              dataIndex={idx}
              suppressNameplate={file.suppressNameplate}
              thumbnailClassName={thumbnailClassName}
            />
          ))}
        {
          [...Array(totalSuccessFilesCount)?.keys()].map((preloadNumber) => {
            return (
              <ThumbnailPreload
                key={preloadNumber}
                thumbnailClassName={thumbnailClassName}
              />
            )
          })
        }
      </div>
    </div>
  );
});

ThumbnailDisplay.propTypes = {
  files: propTypes.arrayOf(propTypes.object),
  className: propTypes.string,
  parentPadding: propTypes.oneOfType([propTypes.number, propTypes.object]),
  thumbnailClassName: propTypes.string,
  totalSuccessFilesCount: propTypes.number,
};

ThumbnailDisplay.displayName = 'ThumbnailDisplay';

export default ThumbnailDisplay;
